import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "marquee-body" }

import { fetchGetMyNoticeListAsync } from "@/typescript/Services/Api/NoticeApi";
import { ref, onMounted, onUnmounted } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'MarqueeWrapperComponent',
  setup(__props, { expose: __expose }) {

const texts = ref<string[]>([]);
const speed = ref<number>(40);
/**
 * 加载数据
 */
function LoadDataAsync() {
    fetchGetMyNoticeListAsync().then(resp => {
        if (resp.CheckIsOk(false)) {
            texts.value.splice(0);
            const list = resp.data!;
            list.forEach(v => {
                texts.value.push(v.Content!);
            });
        }
    })
}

onMounted(() => {
    /**
     * 加载数据
     */
    LoadDataAsync();

});

onUnmounted(() => {
});

__expose({
    LoadDataAsync
});


return (_ctx: any,_cache: any) => {
  const _component_Vue3Marquee = _resolveComponent("Vue3Marquee")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Vue3Marquee, {
      speed: speed.value,
      pauseOnHover: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(texts.value.concat(texts.value), (text, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "item"
          }, _toDisplayString(text), 1))
        }), 128))
      ]),
      _: 1
    }, 8, ["speed"])
  ], 512)), [
    [_vShow, texts.value.length > 0]
  ])
}
}

})